export default __webpack_public_path__ + "static/media/finding-us-01.f40c0494.png";